// ©2024 Austin App House. All rights reserved.
import React from 'react';
import Icon from '../common/Icon';

const ContractorCertificatesChecks = ({
  certificates = [],
  textAlign = 'left',
  infoType = 'icon',
  size = '',
}) => {
  const formatDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    return Number.isNaN(date.getTime())
      ? ''
      : date.toLocaleDateString('en-US', { timeZone: 'UTC' });
  };

  const getPrimaryText = (certificate) => {
    const { certificates_info: info } = certificate;
    if (!info) return '';
    switch (infoType) {
      case 'label':
        return info.label || info.name || '';
      case 'name':
        return info.name || info.label || '';
      case 'icon':
      default:
        return info.name || info.label || '';
    }
  };

  return (
    
      <ul className="card_details certificates_list">
        {certificates?.map((certificate, index) => {
          const primaryText = getPrimaryText(certificate);
          const passedAt = formatDate(certificate.passed_at);
          const expiresAt = formatDate(certificate.expires_at);
          const labelClasses = ['detail_label'];

          const titleText = `${primaryText} ${passedAt ? ` - Passed: ${passedAt}` : ''} ${expiresAt ? ` - Expires: ${expiresAt}` : ''}`;
          if (infoType === 'icon') labelClasses.push('icon_checkbox');

          return (
            <li key={certificate._id + primaryText}>
              <span className="detail_label icon_checkbox">
                <Icon
                  name={certificate.certificates_info.icon} 
                  title={titleText} 
                />
              </span>
            </li>
          );
        })}
      </ul>
  );
};

export default ContractorCertificatesChecks;
